import { carePlanRequestsTyped } from "@/api/(requests)/carePlanTyped";
import type { PatientMedicalCautionsResponse } from "@/core/types";

export async function getMedicalCautions(
  patientId: string,
): Promise<PatientMedicalCautionsResponse> {
  return carePlanRequestsTyped.get_patient_medical_cautions({
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
